import httpClient from "@/services/httpClient";
import { server } from "@/services/constants";

export const checkoutstripepayment = (data) => {
  return httpClient.post(server.STRIPE_PAYMENT + `/create-checkout-session`, data);
};

export const session_statusstripepayment = (data) => {
  return httpClient.get(server.STRIPE_PAYMENT + `/session_status?session_id=${data.session_id}`);
};

export const billingportalstripepayment = (data) => {
  return httpClient.post(server.STRIPE_PAYMENT + `/billingportal`, data);
};

export const checkemailstripepayment = (data) => {
  return httpClient.post(server.STRIPE_PAYMENT + `/checkemail`, data);
};

export const billingportalstripepaymentloginnobilling = (data) => {
  return httpClient.post(server.STRIPE_PAYMENT + `/billingportalloginnobilling`, data);
};